import callApi from './callApi';

export const getTestCaseExecutions = (testCaseId) => {
  const url = `executions/${testCaseId}/test-case-executions`;
  return callApi(url, {}, 'GET');
};

export const getTestCaseExecutionsInTestCycle = (testCaseId) => {
  const url = `executions/testcase-executions/${testCaseId}`;
  return callApi(url, {}, 'GET');
};

export const fetchIterationsByTestCycleId = (testCycleId) => {
  const url = `executions/${testCycleId}/iterations`;
  return callApi(url, {}, 'GET');
};

export const fetchAllExecutionByIteration = (iterationId, page, pageSize, filter,statusFilter) => {
  const url = `executions/${iterationId}/test-case-executions-by-iteration?page=${page}&pageSize=${pageSize}&filter=${filter}&statusFilter=${statusFilter}`;
  return callApi(url, {}, 'GET');
};

export const createTestCaseExecutionsBulk = (data) => {
  const url = `executions/bulkCreate`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'POST', body);
};

export const updateIteration = (data) => {
  const url = `executions/update-iteration`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
};

export const fetchSingleExecution = (executionId) => {
  const url = `executions/${executionId}`;
  return callApi(url, {}, 'GET');
};

export const fetchExecutionTestSteps = (executionId) => {
  const url = `executions/${executionId}/test-steps`;
  return callApi(url, {}, 'GET');
};

export const fetchCurrentExecution = (executionKey, projectId, testCycleId, associatedTestCaseKey) => {
  const url = `executions/${executionKey}/current?testCycleId=${testCycleId}&associatedTestCaseKey=${associatedTestCaseKey}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const updateSingleExecution = (executionId, data) => {
  const url = `executions/${executionId}`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
};

export const deleteExecution = (executionId) => {
  const url = `executions/${executionId}`;
  return callApi(url, {}, 'DELETE');
};


export const checkTestStepsUpdatedOrNot = (testCaseId, executionId) => {
  const url = `executions/steps/${testCaseId}/${executionId}/check-updates`;
  return callApi(url, {}, 'GET');
}

export const updatedTheTestCaseScriptsInExecution = (testCaseId, executionId) => {
  const url = `executions/steps/${testCaseId}/${executionId}/update-scripts`;
  return callApi(url, {}, 'PUT');
}

export const updateSingleScript = (associatedScriptId, data) => {
  const url = `executions/update-script/${associatedScriptId}`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
}

export const bulkUpdateExecutionStep = (data) => {
  const url = `executions/bulk-update-script`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
}
export const fetchFailureData = (executionId) => {
  const url = `failures?executionId=${executionId}`;
  return callApi(url, {}, 'GET');
};

export const addFailureData = (data) => {
  const url = `failures`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'POST', body);
};

export const editFailureData = (data, id) => {
  const url = `failures/${id}`;
  const body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
};

export const removeFailureData = (id) => {
  const url = `failures/${id}`;
  return callApi(url, {}, 'DELETE');
};

export const getProjectConfig = (projectId) => {
  const url = `projects/get-configurations/${projectId}`;
  return callApi(url, {}, 'GET');
};

export const setProjectConfig = (projectId, data) => {
  const url = `projects/set-configurations/${projectId}`;
  const body = {
    ...data,
  }
  return callApi(url, {}, 'POST', body);
};

export const fetchInsightsByIterationId = (iterationId) => {
  const url = `executions/iteration/${iterationId}/insight`;
  return callApi(url, {}, 'GET');
};